import { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { OutsideClick, Button, IconButton } from "@evertrue/et-components";
import classNames from "classnames";
import { generateTimesForInterval } from "base/date-formatter-util";

class CalendarClock extends Component {
  static propTypes = {
    interval_min: PropTypes.number,
    interval_sec: PropTypes.number,
    selectedTimeChanged: PropTypes.func,
    selected_time: PropTypes.number,
  };

  static defaultProps = {
    interval_min: 15,
    interval_sec: 0,
    selectedTimeChanged: () => {},
    selected_time: 0,
  };

  state = {
    time_set: [],
    initial_selection: 0,
    clock_closed: true,
  };

  componentDidMount() {
    const time_set = generateTimesForInterval(this.props.interval_min, this.props.interval_sec);
    this.setState({
      time_set,
    });
  }

  selectedTimeChanged(time) {
    const selected_time = time - moment().startOf("day");
    this.props.selectedTimeChanged(selected_time);
    this.toggleStatus();
  }

  toggleStatus = () => {
    this.setState(
      (state) => {
        return { clock_closed: !state.clock_closed };
      },
      () => {
        if (!this.state.clock_closed && this.selectedRef) {
          this.selectedRef.scrollIntoView({ inline: "center" });
        }
      }
    );
  };

  render() {
    const current_time = moment().startOf("day").millisecond(this.props.selected_time).format("hh:mm a");

    if (this.state.clock_closed) {
      return (
        <div className="calendar-clock--wrapper-closed">
          <div className="calendar-clock--content-closed">
            <div className="calendar-clock--selected-time">{current_time}</div>
            <IconButton className="calendar-clock--dropdown-button" icon="chevron-down" />
            <Button
              type="simple"
              title="Toggle clock"
              className="calendar-clock--content-button"
              onClick={this.toggleStatus}
            />
          </div>
        </div>
      );
    }
    return (
      <OutsideClick onOutsideClick={this.toggleStatus}>
        <div className="calendar-clock--wrapper">
          <div className="calendar-clock--content">
            <ul className="calendar-clock--list">
              {this.state.time_set.map((time, idx) => {
                const time_str = moment(time).format("hh:mm a");
                return (
                  <li
                    key={time}
                    className={classNames("clock-list-item", {
                      "selected-time": current_time === time_str,
                    })}
                    tabIndex={idx}
                    ref={(e) => {
                      if (current_time === time_str) {
                        this.selectedRef = e;
                      }
                    }}
                  >
                    <Button
                      type="simple"
                      title="Select time changes"
                      className="clock-list-button"
                      onClick={() => this.selectedTimeChanged(time)}
                    >
                      {time_str}
                    </Button>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </OutsideClick>
    );
  }
}

export default CalendarClock;
